import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface Props {
  /** What could not be read (e.g. "Pre-enrich scores"). */
  what: string;
  /** Server / degrade detail, when there is one. */
  detail?: string | null;
}

/**
 * Inline note for a gate read that failed or degraded (content-generation's
 * scores, previews, enriched rows). The gate decision does not depend on it,
 * so it informs rather than blocks.
 */
export function GateContentUnavailable({ what, detail }: Props) {
  const { t } = useTranslation('catalog-enrichment-run');
  return (
    <div
      role="status"
      className="bg-muted/50 text-muted-foreground flex items-start gap-2 rounded-lg border border-dashed p-3 text-sm"
    >
      <Info aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
      <div className="flex flex-col gap-0.5">
        <span className="text-foreground font-medium">{t('content.unavailable', { what })}</span>
        <span>{detail ?? t('content.unavailableBody')}</span>
      </div>
    </div>
  );
}
